import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { ReactNode, SyntheticEvent, useState } from 'react';
import { useAtom } from 'jotai';
import * as state from '@/state';
import { KanbanViewerStyles } from './styles';

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
};

export type TabData = {
  label: string;
  content: ReactNode;
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

type Props = {
  data: TabData[];
};

export const ZoneListSwticher = ({ data }: Props) => {
  const [value, setValue] = useState(0);
  const [searchTerm, setSearchTerm] = useAtom(state.zonesSearchTerm);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Box sx={KanbanViewerStyles.rootContainer}>
      <Box sx={KanbanViewerStyles.tabsContainer}>
        <Tabs value={value} onChange={handleChange} aria-label="zone tab switcher">
          {data.map((item, index) => (
            <Tab label={item.label} {...a11yProps(index)} key={item.label} />
          ))}
        </Tabs>
        <TextField
          value={searchTerm}
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder="Search zone"
          sx={KanbanViewerStyles.searchField}
        />
      </Box>

      {data.map((item, index) => (
        <TabPanel value={value} index={index} key={item.label}>
          {item.content}
        </TabPanel>
      ))}
    </Box>
  );
};
